'use strict';

import { Carousel } from './carouselRefactor/carousel';

function isValid() {
  return (document.querySelector( '.cms-carousel-banner-rsp' ) !== null);
}

function initCarouselBanners(){
  for(let container of document.querySelectorAll('.cms-carousel-banner-rsp')){
    new createBanner(container);
  }
}

function createBanner(container) {
  new Carousel(
    {
      carousel_container 		: container, // required
      carousel_name 				: 'cms-carousel-banner-rsp',
      slidesPerView 				: 1,
      slidesPerGroup 				: 1,
      pip_type 							: 'circles',
      display_pips 					: true,
      effect                : 'slide',
      pip_clickable 				: true,
      display_arrows 				: true,
      allow_zoom 						: false,
      loop  			          : true,
      autoplay              : 4000,
      allow_deletion 				: false,
      keyboardControl       : true,
      enlargeView           : false,
      nextSlideMessage      : 'Next',
      prevSlideMessage      : 'Previous',
      items_data 						: 'page',
      items_select					: [
        '.cms-carousel-banner-rsp__item',
        '.cms-supplier-banner'
      ],
      remove_elements 			: [
        '.cms-carousel-banner-rsp__item',
        '.cms-supplier-banner'
      ]
    }
  );
}

if(isValid()) {
  initCarouselBanners();
}

export {
  initCarouselBanners
};
